module.exports = __webpack_public_path__ + "images/stickers/taco-active@2x.afe6f31288619ede4f82.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-active@2x.png
// module id = P/g7
// module chunks = 1